import { Input, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { StateManagementService } from "../providers/state-management/state-management.service";

export class BasePage implements OnDestroy {
  @Input()
  showOrderManagement: boolean = false;
  @Input()
  isPatientChart: boolean = false;
  @Input()
  doShowCtiForm: boolean = false;
  @Input()
  showAdmitStandingOrders: boolean = false;
  @Input()
  HIS: boolean = false;
  @Input()
  hasPalliative: boolean = false;
  @Input()
  hasHospice: boolean = false;
  @Input()
  combineHospicePalliative: boolean = false;
  @Input()
  hasEvaluation: boolean = false;
  @Input()
  hadPalliative: boolean = false;
  @Input()
  hadHospice: boolean = false;
  @Input()
  hadEvaluation: boolean = false;
  @Input()
  hasEligibility: boolean = false;
  @Input()
  showMAR: boolean = false;
  @Input()
  isNewCal: boolean = false;
  @Input()
  PDB: boolean = false;
  @Input()
  showVolunteer: boolean = false;
  @Input()
  showVeteranManagement: boolean = false;
  @Input()
  showProfessionalProviders: boolean = false;
  @Input()
  showChangeOrganization: boolean = false;
  @Input()
  showPRNVisit: boolean = false;
  @Input()
  showVoidVisit: boolean = false;
  @Input()
  showUpdateBilling: boolean = false;
  @Input()
  showNonProviderClinicians: boolean = false;
  @Input()
  showBackOffice: boolean = false;
  @Input()
  showResourceManagement: boolean = false;
  @Input()
  showPalliativeBilling: boolean = false;
  @Input()
  showEfax: boolean = false;
  @Input()
  isPatientCal: boolean = false;
  @Input()
  isEPrescribe: boolean = false;
  @Input()
  showPOCGoalsIntervention: boolean = false;
  @Input()
  showBillingReports: boolean = false;
  @Input()
  showARDetailsDetails: boolean = false;
  @Input()
  showARDetailsSummary: boolean = false;
  @Input()
  showMonthlyRevenueSummary: boolean = false;
  @Input()
  showPreBillingReports: boolean = false;
  @Input()
  showLevelOfCareSummary: boolean = false;
  @Input()
  showLevelOfCareDetails: boolean = false;
  @Input()
  showUnrelatedDiagnosis: boolean = false;
  @Input()
  showResourceReports: boolean = false;
  @Input()
  showPalliativeV1_5: boolean = false;
  @Input()
  showIdgTempChanges: boolean = false;
  @Input()
  showOrderEntryOM: boolean = false;

  showNewAlerts: boolean = false;
  showPatientMedications: boolean = false;
  showPatientAllergies: boolean = false;

  showVolunteerResources: boolean = false;
  showVolunteerResourcesSubscription: Subscription;
  showCommunityBereavement: boolean = false;
  showCommunityBereavementSubscription: Subscription;
  showPalliativeBillingSubscription: Subscription;
  showIsPatientCalSubscription: Subscription;
  showIsPatientEPrescribeSubscription: Subscription;
  showPalliativeV1_5Subscription: Subscription;
  showIdgTempChangesSubscription: Subscription;
  showOrderEntryOMSubscription: Subscription;

  constructor(public stateData: StateManagementService) {
    this.stateData.showOrderManagement.subscribe(
      this.onShowOrderManagementChanged.bind(this)
    );
    this.stateData.isPatientChart.subscribe(
      this.onIsPatientChartChanged.bind(this)
    );
    this.stateData.showCtiForm.subscribe(this.onShowCtiFormChanged.bind(this));
    this.stateData.showAdmitStandingOrders.subscribe(
      this.onShowAdmitStandingOrders.bind(this)
    );
    this.stateData.HIS.subscribe(this.onShowHIS.bind(this));
    this.stateData.hasPalliative.subscribe(this.onHasPalliative.bind(this));
    this.stateData.showMAR.subscribe(this.onShowMAR.bind(this));
    this.stateData.isNewCal.subscribe(this.onIsNewCal.bind(this));
    this.stateData.PDB.subscribe(this.onPdb.bind(this));
    this.stateData.showVolunteer.subscribe(this.onShowVolunteer.bind(this));
    this.stateData.showVeteranManagement.subscribe(
      this.onShowVeteranManagement.bind(this)
    );
    this.stateData.showProfessionalProviders.subscribe(
      this.onShowProfesionalProviders.bind(this)
    );
    this.stateData.showChangeOrganization.subscribe(
      this.onShowChangeOrganization.bind(this)
    );
    this.stateData.showPRNVisit.subscribe(this.onShowPRNVisit.bind(this));
    this.stateData.showEfax.subscribe(this.setEfaxFlag.bind(this));
    this.stateData.showVoidVisit.subscribe(this.setVoidVisit.bind(this));
    this.stateData.showUpdateBilling.subscribe(
      this.setUpdateBilling.bind(this)
    );
    this.stateData.showNonProviderClinicians.subscribe(
      this.onShowNonProviderClinicians.bind(this)
    );
    this.stateData.showBackOffice.subscribe(this.onShowBackOffice.bind(this));
    this.stateData.showResourceManagement.subscribe(
      this.onShowResourceManagement.bind(this)
    );
    this.showIsPatientCalSubscription = this.stateData.isPatientCal.subscribe(
      this.onIsNewPatientCal.bind(this)
    );
    this.showIsPatientEPrescribeSubscription =
      this.stateData.isEPrescribe.subscribe(
        this.onIsPatientEPrescribe.bind(this)
      );
    this.showVolunteerResourcesSubscription =
      this.stateData.showVolunteerResources.subscribe(
        this.onShowVolunteerResources.bind(this)
      );
    this.showCommunityBereavementSubscription =
      this.stateData.showCommunityBereavement.subscribe(
        this.onShowCommunityBereavement.bind(this)
      );
    this.showPalliativeBillingSubscription =
      this.stateData.showPalliativeBilling.subscribe(
        this.onShowPalliativeBilling.bind(this)
      );
    this.stateData.showUnrelatedDiagnosis.subscribe(
      this.setUnrelatedDiagnosisFlag.bind(this)
    );
    this.stateData.hasHospice.subscribe(this.onHasHospice.bind(this));
    this.stateData.hadPalliative.subscribe(this.onHadPalliative.bind(this));
    this.stateData.hadHospice.subscribe(this.onHadHospice.bind(this));
    this.stateData.hasEligibility.subscribe(this.onHasEligibility.bind(this));
    this.stateData.hasEvaluation.subscribe(this.onHasEvaluation.bind(this));
    this.stateData.hadEvaluation.subscribe(this.onHadEvaluation.bind(this));
    this.stateData.showNewAlerts.subscribe(this.onShowNewAlerts.bind(this));
    this.stateData.showPocGoalsInterventions.subscribe(
      this.setPOCGoalsInterventions.bind(this)
    );
    this.stateData.showBillingReports.subscribe(
      this.onShowBillingReports.bind(this)
    );
    this.stateData.showARDetailsDetails.subscribe(
      this.onShowARDetailsDetails.bind(this)
    );
    this.stateData.showARDetailsSummary.subscribe(
      this.onShowARDetailsSummary.bind(this)
    );
    this.stateData.showMonthlyRevenueSummary.subscribe(
      this.onShowMonthlyRevenueSummary.bind(this)
    );
    this.stateData.showPreBillingReports.subscribe(
      this.onShowPreBillingReports.bind(this)
    );
    this.stateData.showLevelOfCareSummary.subscribe(
      this.onShowLevelOfCareSummary.bind(this)
    );
    this.stateData.showLevelOfCareDetails.subscribe(
      this.onShowLevelOfCareDetails.bind(this)
    );
    this.stateData.showResourceReports.subscribe(
      this.onShowResourceReports.bind(this)
    );
    this.stateData.showPatientMedications.subscribe(
      this.onShowPatientMedications.bind(this)
    );
    this.stateData.showPatientAllergies.subscribe(
      this.onShowPatientAllergies.bind(this)
    );
    this.stateData.showPalliativeV1_5.subscribe(
      this.onShowPalliativeV1_5.bind(this)
    );
    this.showIdgTempChangesSubscription =
      this.stateData.showIdgTempChanges.subscribe(
        this.onshowIdgTempChanges.bind(this)
      );
    this.showOrderEntryOMSubscription =
      this.stateData.showOrderEntryOM.subscribe(
        this.onShowOrderEntryOM.bind(this)
      );
  }

  protected onShowPatientAllergies(newValue: boolean): void {
    this.showPatientAllergies = newValue;
  }

  protected onShowPatientMedications(newValue: boolean): void {
    this.showPatientMedications = newValue;
  }

  protected onShowResourceReports(newValue: boolean): void {
    this.showResourceReports = newValue;
  }

  protected onCombineHospicePalliative(newValue: boolean): void {
    this.combineHospicePalliative = newValue;
  }

  protected onShowNewAlerts(newValue: boolean): void {
    this.showNewAlerts = newValue;
  }
  protected onShowPalliativeBilling(newValue: boolean): void {
    this.showPalliativeBilling = newValue;
  }

  protected onIsNewPatientCal(newValue: boolean): void {
    this.isPatientCal = newValue;
  }

  protected onIsPatientEPrescribe(newValue: boolean): void {
    this.isEPrescribe = newValue;
  }

  protected onShowCommunityBereavement(newValue: boolean): void {
    this.showCommunityBereavement = newValue;
  }

  protected onShowVolunteerResources(newValue: boolean): void {
    this.showVolunteerResources = newValue;
  }

  protected onShowResourceManagement(newValue): void {
    this.showResourceManagement = newValue;
  }

  protected onShowNonProviderClinicians(newValue): void {
    this.showNonProviderClinicians = newValue;
  }

  protected onShowBackOffice(newValue): void {
    this.showBackOffice = newValue;
  }

  protected onShowProfesionalProviders(newValue): void {
    this.showProfessionalProviders = newValue;
  }
  protected onHasPalliative(newValue): void {
    this.hasPalliative = newValue;
  }

  protected onHasHospice(newValue): void {
    this.hasHospice = newValue;
  }

  protected onHasEvaluation(newValue): void {
    this.hasEvaluation = newValue;
  }

  protected onHadEvaluation(newValue): void {
    this.hadEvaluation = newValue;
  }

  protected onHadPalliative(newValue): void {
    this.hadPalliative = newValue;
  }

  protected onShowBillingReports(newValue): void {
    this.showBillingReports = newValue;
  }

  protected onShowARDetailsDetails(newValue): void {
    this.showARDetailsDetails = newValue;
  }

  protected onShowARDetailsSummary(newValue): void {
    this.showARDetailsSummary = newValue;
  }

  protected onShowMonthlyRevenueSummary(newValue): void {
    this.showMonthlyRevenueSummary = newValue;
  }

  protected onShowPreBillingReports(newValue): void {
    this.showPreBillingReports = newValue;
  }

  protected onShowLevelOfCareSummary(newValue): void {
    this.showLevelOfCareSummary = newValue;
  }

  protected onShowLevelOfCareDetails(newValue): void {
    this.showLevelOfCareDetails = newValue;
  }

  protected onHadHospice(newValue): void {
    this.hadHospice = newValue;
  }

  protected onHasEligibility(newValue): void {
    //this.hasEligibility = newValue;
    this.hasEligibility = false;
  }

  protected onShowOrderManagementChanged(newValue) {
    this.showOrderManagement = newValue;
  }

  protected onIsPatientChartChanged(newValue) {
    this.isPatientChart = newValue;
  }

  protected onShowCtiFormChanged(newValue) {
    this.doShowCtiForm = newValue;
  }

  protected onShowChangeOrganization(newValue): void {
    this.showChangeOrganization = newValue;
  }

  protected onShowPRNVisit(newValue): void {
    this.showPRNVisit = newValue;
  }

  protected get showCtiFlag(): BehaviorSubject<boolean> {
    return this.stateData.showCtiForm;
  }

  protected get getPRNVisitFlag(): BehaviorSubject<boolean> {
    return this.stateData.showPRNVisit;
  }

  protected setVoidVisit(newValue): void {
    this.showVoidVisit = newValue;
  }

  protected get getVoidVisitFlag(): BehaviorSubject<boolean> {
    return this.stateData.showVoidVisit;
  }

  protected get getConcurrentVisitsFlag(): BehaviorSubject<boolean> {
    return this.stateData.concurrentVisitsToggle;
  }

  protected setPOCGoalsInterventions(newValue): void {
    this.showPOCGoalsIntervention = newValue;
  }

  protected get getPOCGoalsInterventions(): BehaviorSubject<boolean> {
    return this.stateData.showPocGoalsInterventions;
  }

  protected setUpdateBilling(newValue): void {
    this.showUpdateBilling = newValue;
  }

  protected get getUpdateBillingFlag(): BehaviorSubject<boolean> {
    return this.stateData.showUpdateBilling;
  }

  protected get getEFaxFlag(): BehaviorSubject<boolean> {
    return this.stateData.showEfax;
  }

  protected setEfaxFlag(newValue): void {
    this.showEfax = newValue;
  }

  protected get getUnrelatedDiagnosisFlag(): BehaviorSubject<boolean> {
    return this.stateData.showUnrelatedDiagnosis;
  }

  protected setUnrelatedDiagnosisFlag(newValue): void {
    this.showUnrelatedDiagnosis = newValue;
  }

  protected onShowAdmitStandingOrders(newValue) {
    return (this.showAdmitStandingOrders = newValue);
  }

  protected onShowHIS(newValue) {
    this.HIS = newValue;
  }

  protected onShowMAR(newValue) {
    this.showMAR = newValue;
  }

  protected onIsNewCal(newValue) {
    this.isNewCal = newValue;
  }

  protected onPdb(newValue) {
    this.PDB = newValue;
  }

  protected onShowVolunteer(newValue) {
    this.showVolunteer = newValue;
  }

  protected onShowVeteranManagement(newValue) {
    this.showVeteranManagement = newValue;
  }

  protected onShowPalliativeV1_5(newValue: boolean): void {
    this.showPalliativeV1_5 = newValue;
  }

  protected onshowIdgTempChanges(newValue: boolean): void {
    this.showIdgTempChanges = newValue;
  }

  protected onShowOrderEntryOM(newValue: boolean): void {
    this.showOrderEntryOM = newValue;
  }

  ngOnDestroy(): void {
    if (this.showVolunteerResourcesSubscription) {
      this.showVolunteerResourcesSubscription.unsubscribe();
    }
    if (this.showCommunityBereavementSubscription) {
      this.showCommunityBereavementSubscription.unsubscribe();
    }
    if (this.showPalliativeBillingSubscription) {
      this.showPalliativeBillingSubscription.unsubscribe();
    }
    if (this.showIsPatientEPrescribeSubscription) {
      this.showIsPatientEPrescribeSubscription.unsubscribe();
    }
    if (this.showIsPatientCalSubscription) {
      this.showIsPatientCalSubscription.unsubscribe();
    }
    if (this.showPalliativeV1_5Subscription) {
      this.showPalliativeV1_5Subscription.unsubscribe();
    }
    if (this.showIdgTempChangesSubscription) {
      this.showIdgTempChangesSubscription.unsubscribe();
    }
    if (this.showOrderEntryOMSubscription) {
      this.showOrderEntryOMSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/base-page.ts